<template>
  <div class="px-4 py-3">
    <vetster-input
      id="breed"
      ref="breedInput"
      v-model.trim="inputs.breed"
      is-rebranded
      name="breed"
      type="text"
      :label="$t('pets.breed')"
      :shake="shouldShake('breed', v$.inputs.breed.$error)"
      :error="hasError('breed', v$.inputs.breed.$error)"
      :feedback="getErrorMessage('breed', v$.inputs.breed.$error, $t('pets.errors.please-enter-your-pet-s-breed'))"
    />
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

import ParseErrors from '@/mixins/ParseErrors';

export default {
  name: 'VetsterBreedForm',

  mixins: [ParseErrors],

  props: {
    formInputs: {
      type: Object,
      default: () => ({}),
    },
  },

  validations: {
    inputs: {
      breed: {
        required,
      },
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  data() {
    return {
      inputs: {
        breed: this.formInputs?.breed,
      },
    };
  },

  watch: {
    'inputs.breed': {
      handler(newValue) {
        this.$emit('input', {
          ...this.formInputs,
          breed: newValue,
        });
      },
      immediate: true,
    },
  },

  mounted() {
    this.focusBreed();
  },

  methods: {
    focusBreed() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.breedInput?.focus();
        }, 400);
      });
    },
  },
};
</script>
